import { render, staticRenderFns } from "./k-header.vue?vue&type=template&id=984c8462&lang=pug&"
import script from "./k-header.vue?vue&type=script&lang=js&"
export * from "./k-header.vue?vue&type=script&lang=js&"
import style0 from "./k-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('984c8462')) {
      api.createRecord('984c8462', component.options)
    } else {
      api.reload('984c8462', component.options)
    }
    module.hot.accept("./k-header.vue?vue&type=template&id=984c8462&lang=pug&", function () {
      api.rerender('984c8462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-header.vue"
export default component.exports